/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-22 11:11:46
 */

import Vue from 'vue'
import axios from 'axios'
import { getCookie } from '@/js/utils'
import QS from 'qs'
import { polyfill } from 'es6-promise' //Promise兼容
polyfill();
// var axios = axios.create({
//     // baseURL: 'http://192.168.20.231',
//     // baseURL: '',
//     // port:8080,
//     withCredentials: true,
//     timeout: 10000,
//     responseType: 'json',
//     headers: {
//         // 'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'   //转换为key=value的格式必须增加content-type
//         // 'Content-Type':'application/json;charset=utf-8'
//         // 'Content-Type': 'multipart/form-data'
//     },
//     transformRequest: [function(data){
//       return QS.stringify(data)    //利用对应方法转换格式
//     }]
// });

axios.defaults.timeout = 0;
axios.defaults.withCredentials = true;
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
//ajax / post
const Post = (URL, data, self = null, extraData = { message: false, config: null, file: false }) => {
    
    return new Promise(async (resolve, reject) => {
        // let _path = self != null ? self.$route.path : window.location.pathname;
        let _path = self.$route.path;
        if(self.$route.meta.type == 'manager'){
            getCookie('ticket') != null ? axios.defaults.headers.common['token'] = getCookie('ticket') : '';
        }else{
            getCookie('token') != null ? axios.defaults.headers.common['token'] = getCookie('token') : '';
        }
        if (extraData.file) {
            delete axios.defaults.responseType;
            delete axios.defaults.transformRequest;
        } else {
            axios.defaults.responseType = 'json';
            axios.defaults.transformRequest = [function(data) {
                return QS.stringify(data) //利用对应方法转换格式
            }];
        }
        axios.post(URL, data, extraData.config)
        .then((response) => {
            // console.log(response)
            // 请求响应成功
            if (response.status == 200) {
                // console.log(response.data)
                // // 接口返回成功
                if (response.data.code == 200) { 
                    resolve(response.data.data)
                    // callBack(response.data.data)
                } else if(response.data.code == -1){
                    self.$toast(
                        response.data.message,
                        'warning',
                        2000
                    )
                    if(self.$route.meta.type == 'manager'){//管理员
                        self.$setCookie("ticket",null,-1);
                        self.$router.push({name: self.$route.meta.login,query: {redirect: self.$route.fullPath}});
                    }else{
                        self.$setCookie("token",null,-1);
                        self.$clearSessionStorage();
                        self.$router.push({name:'wxAuther',query:{redirect: self.$route.fullPath}});
                    }
                } else {
                    if (extraData.message) {
                        self.$toast(
                            response.data.message,
                            'warning',
                            2000
                        )
                        resolve('false')
                    } else {
                        resolve(response.data)
                        // callBack(response.data)
                    }
                }
            } else {
                if (extraData.message) {
                    self.$toast(
                        response.data.message,
                        'warning',
                        2000
                    )
                } else {
                    // callBack(response.data.message)
                    resolve(response.data.message)
                }
            }
        })
        .catch(error => {
            console.log(error)
            reject(error);
            if (extraData.message) {
                self.$toast(
                    error,
                    'error',
                    2000
                )
            }
        })
    })
}
    //ajax / get
const Get = (URL, data, callBack, self = null, extraData = { message: false, config: null, down: false }) => {
        // Vue.prototype.$getSessionStorage("token") != null ? axios.defaults.headers.common['token'] = getCookie('token') : '';
        getCookie('token') != null ? axios.defaults.headers.common['token'] = getCookie('token') : '';
        axios.get(URL, {
                params: data,
                timeout: 0,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                withCredentials: true
            })
            .then((response) => {
                console.log(response)
                    // 请求响应成功
                if (response.status == 200) {
                    // console.log(response.data)
                    // // 接口返回成功
                    if (response.data.code == 200) {
                        callBack(response.data.data)
                    } else {
                        if (extraData.message) {
                            self.$toast({
                                message: response.data.message,
                                type: 'warning',
                                duration: 2000
                            })
                        } else {
                            callBack(response.data)
                        }
                    }
                } else {
                    if (extraData.message) {
                        self.$toast({
                            message: response.data.message,
                            type: 'error',
                            duration: 2000
                        })
                    } else {
                        callBack(response.data)
                    }
                }
            }, (error) => {
                if (extraData.message) {
                    self.$toast({
                        message: error,
                        type: 'error',
                        duration: 2000
                    })
                } else {
                    console.log(error)
                }
            })
    }
    //自定义拼接URL  ajax / http
const Http = (URL, data, callBack, self = null) => {

}

export default {
    Post,
    Get,
    Http,
}


// WEBPACK FOOTER //
// ./src/api/request.js